(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 67154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G$": function() { return /* binding */ ExternalBanner; },
/* harmony export */   "Gr": function() { return /* binding */ InternalBanner; },
/* harmony export */   "gm": function() { return /* binding */ ShowMore; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96502);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41686);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);



var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Calendarelements__Wrapper",
  componentId: "sc-bbtzei-0"
})(["padding:0 0 ", " 0;margin-top:", ";"], (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hO)(40), (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hO)(20));
var InternalBanner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "Calendarelements__InternalBanner",
  componentId: "sc-bbtzei-1"
})(["width:100%;margin-bottom:", ";"], (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hO)(15));
var ExternalBanner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Calendarelements__ExternalBanner",
  componentId: "sc-bbtzei-2"
})(["margin-bottom:", ";display:none;@media (min-width:", "px){display:block;}img{width:100%;}"], (0,polished__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hO)(15), _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .breakpoints.xs */ .A.xs);
var ShowMore = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Calendarelements__ShowMore",
  componentId: "sc-bbtzei-3"
})(["display:flex;justify-content:center;"]);

/***/ }),

/***/ 16563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Clients_Clients; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Clients/Clients.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Wrapper",
  componentId: "sc-1992s35-0"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(50));
var Clients = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Clients",
  componentId: "sc-1992s35-1"
})(["display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;"]);
var Client = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Clientselements__Client",
  componentId: "sc-1992s35-2"
})(["display:flex;justify-content:center;align-items:center;padding:", ";padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40));
var ClientImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Clientselements__ClientImage",
  componentId: "sc-1992s35-3"
})(["width:", ";margin:0 auto;"], (0,polished_esm/* rem */.hO)(130));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Clients/Clients.tsx










var ClientsTemplate = function ClientsTemplate(_ref) {
  var titleKey = _ref.titleKey,
      showClients = _ref.showClients,
      showPartners = _ref.showPartners;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(0),
      visibleKey = _useState[0],
      setVisibleKey = _useState[1];

  (0,useScrollToSection/* default */.Z)('nasi-partneri', 'partneri');
  var clients = ['/italians_logo.png', '/valeo_logo.png', '/keramtech_logo.png', '/safran_logo.png', '/hyundai_logo.png', '/nexen_logo.png', '/danfos_logo.png'];
  var partners = ['/skoleni_logo.png', '/grada_logo.png', '/sagit_logo.png', '/educity_logo.png', '/dane-pro-lidi.jpg', '/mzdy-pro-lidi.jpg', '/sluto.jpg'];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    id: "partneri",
    mobileSidePadding: 20,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        isBlack: true,
        children: t(titleKey)
      }), showClients && /*#__PURE__*/(0,jsx_runtime.jsx)(Clients, {
        children: clients.map(function (client, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Client, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClientImage, {
              src: (0,url_utils/* publicAssets */.VK)(client)
            })
          }, index);
        })
      }), showPartners && /*#__PURE__*/(0,jsx_runtime.jsx)(Clients, {
        children: partners.map(function (partner, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Client, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClientImage, {
              src: (0,url_utils/* publicAssets */.VK)(partner)
            })
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var Clients_Clients = (ClientsTemplate);

/***/ }),

/***/ 94806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompanyCourses; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CompanyCourses/CompanyCourses.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Background",
  componentId: "sc-wq8y90-0"
})(["background:rgba(116,120,129,0.08);padding:", ";@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(80));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Wrapper",
  componentId: "sc-wq8y90-1"
})(["@media (min-width:", "px){display:flex;flex-direction:row;}"], theme/* breakpoints.md */.A.md);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "CompanyCourseselements__Title",
  componentId: "sc-wq8y90-2"
})(["font-weight:", ";font-family:", ";font-size:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.fontSecondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CompanyCourseselements__Label",
  componentId: "sc-wq8y90-3"
})(["color:", ";font-size:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.grey;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
});
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "CompanyCourseselements__Description",
  componentId: "sc-wq8y90-4"
})(["line-height:", ";font-weight:", ";margin:", " 0 ", " 0;font-size:", ";@media (min-width:", "px){margin:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(29), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h6;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(40));
var Benefits = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "CompanyCourseselements__Benefits",
  componentId: "sc-wq8y90-5"
})(["color:", ";padding:0 ", ";font-size:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(20), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h6;
});
var Benefit = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "CompanyCourseselements__Benefit",
  componentId: "sc-wq8y90-6"
})(["padding:", " 0 ", " ", ";&::marker{color:", ";width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(4));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "CompanyCourseselements__Image",
  componentId: "sc-wq8y90-7"
})(["display:block;width:100%;@media (min-width:", "px){margin-left:5%;width:40%;max-height:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(500));
var Texts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Texts",
  componentId: "sc-wq8y90-8"
})(["width:100%;@media (min-width:", "px){width:60%;}"], theme/* breakpoints.md */.A.md);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CompanyCourses/CompanyCourses.tsx











var CompanyCoursesTemplate = function CompanyCoursesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Texts, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
            children: t('homepage.companyCourses.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
            children: t('homepage.companyCourses.description')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
            children: t('homepage.companyCourses.label')
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefits, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit1')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit2')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit3')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit4')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit5')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit6')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit7')
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Benefit, {
              children: t('homepage.companyCourses.benefit8')
            })]
          }), !router.pathname.includes(constants/* ROUTES.COMPANY_COURSES */.Z6.COMPANY_COURSES) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            marginTop: 15,
            marginBottom: 45,
            size: Button/* ButtonSizes.SMALL */.P.SMALL,
            onClick: function onClick() {
              return router.push({
                pathname: constants/* ROUTES.SUBSCRIPTION */.Z6.SUBSCRIPTION
              });
            },
            whiteType: true,
            text: t('homepage.companyCourses.button')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: (0,url_utils/* publicAssets */.VK)('/courses.png')
        })]
      })
    })
  });
};

/* harmony default export */ var CompanyCourses = (CompanyCoursesTemplate);

/***/ }),

/***/ 67450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Exhibitors_Exhibitors; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.elements.tsx




var Exhibitors = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitors",
  componentId: "sc-1deaujm-0"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Exhibitor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitor",
  componentId: "sc-1deaujm-1"
})(["display:flex;flex-direction:column;width:100%;padding:0;margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20));
var ExhibitorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__ExhibitorTitle",
  componentId: "sc-1deaujm-2"
})(["padding:", " 0 ", " 0;font-weight:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
});
var ExhibitorAnnotation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Exhibitorselements__ExhibitorAnnotation",
  componentId: "sc-1deaujm-3"
})(["color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
});
var ExhibitorImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Exhibitorselements__ExhibitorImage",
  componentId: "sc-1deaujm-4"
})(["width:", ";height:", ";border-radius:", ";@media (min-width:", "px){width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(155), (0,polished_esm/* rem */.hO)(180), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(190), (0,polished_esm/* rem */.hO)(220));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ExhibitorsTemplate = function ExhibitorsTemplate() {
  var _lecturers$sort;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      lecturers = _useState[0],
      setLecturers = _useState[1];

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    responsive: [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false
      }
    }]
  };
  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.list */.r.list().then(function (_ref) {
      var data = _ref.data;
      setLecturers(data.results);
    });
  }, []);
  return (lecturers === null || lecturers === void 0 ? void 0 : lecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      isBlack: true,
      children: t('homepage.lecturer.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({}, settings), {}, {
        children: lecturers === null || lecturers === void 0 ? void 0 : (_lecturers$sort = lecturers.sort(function (a, b) {
          return a.in_carousel - b.in_carousel;
        })) === null || _lecturers$sort === void 0 ? void 0 : _lecturers$sort.map(function (lecturer, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Exhibitor, {
            onClick: function onClick() {
              return router.push("".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(lecturer.slug));
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorImage, {
              src: lecturer.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar_height.jpg')),
              width: 0,
              height: 0,
              alt: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key),
              loader: function loader(_ref2) {
                var src = _ref2.src;
                return src;
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorTitle, {
              children: (0,person_utils/* formatLecturerName */.v)(lecturer)
            }), (lecturer === null || lecturer === void 0 ? void 0 : lecturer.position) && /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorAnnotation, {
              children: lecturer.position
            })]
          }, key);
        })
      }))
    })]
  });
};

/* harmony default export */ var Exhibitors_Exhibitors = (ExhibitorsTemplate);

/***/ }),

/***/ 59922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49642);





var useScrollToSection = function useScrollToSection(sectionNameInPathname, sectionIdInHtml) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.asPath.includes(sectionNameInPathname)) {
      var element = document.getElementById(sectionIdInHtml);
      return window.scrollTo({
        top: element.offsetTop - (window.innerWidth > _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.sm */ .A.sm ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .DESKTOP_HEADER_HEIGHT */ .cf : _constants__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_HEADER_HEIGHT */ .ZQ),
        behavior: 'smooth'
      });
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useScrollToSection);

/***/ }),

/***/ 46339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/components/Event/Event.tsx + 3 modules
var Event = __webpack_require__(76510);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Spinner/Spinner.tsx + 1 modules
var Spinner = __webpack_require__(77368);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/interfaces/Calendar.ts
var Calendar = __webpack_require__(17923);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
// EXTERNAL MODULE: ./src/store/ui.ts
var ui = __webpack_require__(18770);
// EXTERNAL MODULE: ./src/components/Calendar/Calendar.elements.tsx
var Calendar_elements = __webpack_require__(67154);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Calendar/Calendar.tsx




















var COUNT_OF_EVENTS_ON_PAGE = 6;
var INTERNAL_BANNER_POSITION = 3;
var EXTERNAL_BANNER_POSITION = 4;

var CalendarTemplate = function CalendarTemplate(_ref) {
  var data = _ref.events,
      count = _ref.count;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(data),
      events = _useState[0],
      setEvents = _useState[1];

  var _useState2 = (0,react.useState)(count),
      totalCount = _useState2[0],
      setTotalCount = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var _useState4 = (0,react.useState)([]),
      banners = _useState4[0],
      setBanners = _useState4[1];

  var _useState5 = (0,react.useState)(Calendar/* BannerTypes.DESKTOP */.f0.DESKTOP),
      bannerVersion = _useState5[0],
      setBannerVersion = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      externalBannerScript = _useState6[0],
      setExternalBannerScript = _useState6[1];

  var isLoggedIn = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });
  var needToUpdateFavoriteList = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.needToUpdateFavoriteList;
  });

  var showMore = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _yield$calendarApi$ge, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return calendar_service/* calendarApi.getUpComingEvents */.w.getUpComingEvents(new Date().toString(), js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY */.Wx), COUNT_OF_EVENTS_ON_PAGE, events === null || events === void 0 ? void 0 : events.length);

            case 3:
              _yield$calendarApi$ge = _context.sent;
              data = _yield$calendarApi$ge.data;
              setEvents([].concat((0,toConsumableArray/* default */.Z)(events), (0,toConsumableArray/* default */.Z)(data === null || data === void 0 ? void 0 : data.results)));
              setTotalCount(data === null || data === void 0 ? void 0 : data.total_count);
              setIsLoading(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showMore() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (needToUpdateFavoriteList) {
      setIsLoading(true);
      calendar_service/* calendarApi.getUpComingEvents */.w.getUpComingEvents(new Date().toString(), js_cookie/* default.get */.Z.get(constants/* ACCESS_TOKEN_KEY */.Wx), events === null || events === void 0 ? void 0 : events.length).then(function (_ref3) {
        var data = _ref3.data;
        setEvents(data === null || data === void 0 ? void 0 : data.results);
        setTotalCount(data === null || data === void 0 ? void 0 : data.total_count);
        setIsLoading(false);
      });
      dispatch((0,ui/* setIsNeedToUpdateFavoriteList */.RH)(false));
    }
  }, [needToUpdateFavoriteList]);
  (0,react.useEffect)(function () {
    calendar_service/* calendarApi.getHomepageBanners */.w.getHomepageBanners().then(function (_ref4) {
      var data = _ref4.data;
      return setBanners((data === null || data === void 0 ? void 0 : data.results) || []);
    });
    fetch("".concat((0,constants/* getAdsUrl */.fu)(), "&zoneid=65")).then(function (response) {
      return response.text();
    })["catch"](function () {
      return null;
    }).then(function (data) {
      var _data$replace;

      setExternalBannerScript(data === null || data === void 0 ? void 0 : (_data$replace = data.replace(')', '')) === null || _data$replace === void 0 ? void 0 : _data$replace.replace('document.write(', 'document.getElementById("homepageBanner").innerHTML = '));
    });
  }, []);
  (0,react.useEffect)(function () {
    if (window.innerWidth >= 1180) setBannerVersion(Calendar/* BannerTypes.DESKTOP */.f0.DESKTOP);
    if (window.innerWidth >= 768 && window.innerWidth < 1180) setBannerVersion(Calendar/* BannerTypes.TABLET */.f0.TABLET);
    if (window.innerWidth < 768) setBannerVersion(Calendar/* BannerTypes.MOBILE */.f0.MOBILE);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Calendar_elements/* Wrapper */.im, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('homepage.calendar.title')
    }), events === null || events === void 0 ? void 0 : events.map(function (event, key) {
      var _banners$index, _banners$index2;

      var index = Math.floor(Math.random() * banners.length);
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [key === INTERNAL_BANNER_POSITION && (banners === null || banners === void 0 ? void 0 : banners.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          href: (_banners$index = banners[index]) === null || _banners$index === void 0 ? void 0 : _banners$index.redirect_url,
          rel: "noreferrer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_elements/* InternalBanner */.Gr, {
            src: "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/image/").concat(bannerVersion, "_").concat((_banners$index2 = banners[index]) === null || _banners$index2 === void 0 ? void 0 : _banners$index2._key, "/file")
          })
        }), key === EXTERNAL_BANNER_POSITION && externalBannerScript && !isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_elements/* ExternalBanner */.G$, {
          id: "homepageBanner",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
            children: externalBannerScript
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Event/* default */.Z, {
          iKey: key,
          event: event
        })]
      });
    }), (events === null || events === void 0 ? void 0 : events.length) < totalCount && /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_elements/* ShowMore */.gm, {
      children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {
        size: 32
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        marginTop: 30,
        onClick: showMore,
        text: t('homepage.calendar.button.more')
      })
    })]
  });
};

/* harmony default export */ var Calendar_Calendar = (CalendarTemplate);
// EXTERNAL MODULE: ./src/components/Clients/Clients.tsx + 1 modules
var Clients = __webpack_require__(16563);
// EXTERNAL MODULE: ./src/hooks/useScrollToSection.ts
var useScrollToSection = __webpack_require__(59922);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/References/References.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Background",
  componentId: "sc-1066rkm-0"
})(["background:#f6f6f6;padding:", ";"], (0,polished_esm/* rem */.hO)(30));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Wrapper",
  componentId: "sc-1066rkm-1"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(50));
var References_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Content",
  componentId: "sc-1066rkm-2"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(50));
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Section",
  componentId: "sc-1066rkm-3"
})(["display:flex;flex-direction:column;padding:", " 0 ", " 0;@media (min-width:", "px){flex-direction:row;}@media (min-width:", "px){align-items:center;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Referenceselements__Image",
  componentId: "sc-1066rkm-4"
})(["height:auto;width:80%;border-radius:", ";margin-bottom:", ";margin-right:10%;margin-left:10%;@media (min-width:", "px){width:200px;margin-right:5%;margin-left:", ";}"], (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(-20));
var Reviews = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Reviews",
  componentId: "sc-1066rkm-5"
})([""]);
var Review = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Review",
  componentId: "sc-1066rkm-6"
})(["&.isVisible{display:block;}&.isHidden{display:none;}"]);
var ReviewText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Referenceselements__ReviewText",
  componentId: "sc-1066rkm-7"
})(["margin:0;font-size:", ";line-height:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
});
var ReviewAuthor = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Referenceselements__ReviewAuthor",
  componentId: "sc-1066rkm-8"
})(["font-weight:", ";color:", ";line-height:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(24));
var Slider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Referenceselements__Slider",
  componentId: "sc-1066rkm-9"
})(["width:100%;padding:", " 0;display:flex;justify-content:center;@media (min-width:", "px){justify-content:flex-end;margin-top:", ";z-index:99;position:relative;background:transparent;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(-110));
var SliderButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Referenceselements__SliderButton",
  componentId: "sc-1066rkm-10"
})(["background:none;border:none;cursor:pointer;svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40));
;// CONCATENATED MODULE: ./src/components/References/References.tsx












var ReferencesTemplate = function ReferencesTemplate(_ref) {
  var titleKey = _ref.titleKey;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(0),
      visibleKey = _useState[0],
      setVisibleKey = _useState[1];

  (0,useScrollToSection/* default */.Z)('nasi-partneri', 'partneri');
  var REFERENCES = [{
    company: 'HR manažer',
    name: 'Tomáš Klečka',
    comment: 'Prakticky zaměřené školení s uvedením konkrétních příkladů a doporučení pro zaměstnavatele. Vše probíhá velmi profesionálně v čistých, útulných učebnách a s připraveným občerstvení.'
  }, {
    company: 'referentka',
    name: 'Jana',
    comment: 'Naprosto profi kurz. Skvěle připraveno – hlavně příklady z praxe.'
  }, {
    company: 'zástupkyně vedení',
    name: 'Iveta Cafourková',
    comment: 'Velmi pozitivní přednáška PaedDr. Štursy, který dokáže zaujmout a upoutat pozornost. Příjemně strávený den.'
  }, {
    company: 'účetní',
    name: 'Lucie',
    comment: 'Na kurzech ve Studiu W se mi velmi líbí prostory, pohoštění, ale hlavně náplň a zaujetí přednášejících.'
  }, {
    company: 'technička',
    name: 'Lucie Kučerová',
    comment: 'Kurz mě pozitivně naladil. Horší bude informace a dovednosti aplikovat. Výborné vedení pana lektora Štursy.'
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Background, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      id: "reference",
      mobileSidePadding: 20,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
          tagType: Title/* TitleTagTypes.H3 */.Z.H3,
          isBlack: true,
          children: t(titleKey)
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
            src: (0,url_utils/* publicAssets */.VK)('/clients.webp')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Reviews, {
            children: REFERENCES.map(function (reference, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Review, {
                className: key === visibleKey ? 'isVisible' : 'isHidden',
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReviewText, {
                  dangerouslySetInnerHTML: {
                    __html: reference === null || reference === void 0 ? void 0 : reference.comment
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReviewAuthor, {
                  children: [reference === null || reference === void 0 ? void 0 : reference.name, " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", reference === null || reference === void 0 ? void 0 : reference.company]
                })]
              }, key);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
          mobileSidePadding: 20,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Slider, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SliderButton, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: visibleKey > 0 ? Icon/* Icons.ArrowCircleLeftActive */.PJ.ArrowCircleLeftActive : Icon/* Icons.ArrowCircleLeftDisabled */.PJ.ArrowCircleLeftDisabled,
                onClick: function onClick() {
                  return setVisibleKey(visibleKey > 0 ? visibleKey - 1 : 0);
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SliderButton, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: visibleKey < REFERENCES.length - 1 ? Icon/* Icons.ArrowCircleRightActive */.PJ.ArrowCircleRightActive : Icon/* Icons.ArrowCircleRightDisabled */.PJ.ArrowCircleRightDisabled,
                onClick: function onClick() {
                  return setVisibleKey(visibleKey < REFERENCES.length - 1 ? visibleKey + 1 : visibleKey);
                }
              })
            })]
          })
        })]
      })
    })
  });
};

/* harmony default export */ var References = (ReferencesTemplate);
// EXTERNAL MODULE: ./src/components/CompanyCourses/CompanyCourses.tsx + 1 modules
var CompanyCourses = __webpack_require__(94806);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(90359);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/HomepageHero/Hero.elements.tsx




var Hero_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1wbd4o9-0"
})(["padding:", ";max-width:", ";margin:", " auto 0 auto;color:", ";@media (min-width:", "px){padding:", " ", ";margin:", " auto 0 auto;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1250), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf));
var Top = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Top",
  componentId: "sc-1wbd4o9-1"
})(["display:flex;flex-direction:column-reverse;gap:", ";@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm);
var HeroLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__HeroLink",
  componentId: "sc-1wbd4o9-2"
})(["width:100%;@media (min-width:", "px){min-width:55%;width:55%;}"], theme/* breakpoints.sm */.A.sm);
var HeroImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__HeroImage",
  componentId: "sc-1wbd4o9-3"
})(["width:100%;height:auto;border-radius:", ";@media (min-width:", "px){width:100%;}"], (0,polished_esm/* rem */.hO)(24), theme/* breakpoints.sm */.A.sm);
var Benefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefits",
  componentId: "sc-1wbd4o9-4"
})(["display:flex;justify-content:space-between;padding:", " 0 ", " 0;flex-wrap:wrap;margin-top:", ";"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1wbd4o9-5"
})(["@media (min-width:", "px){padding-left:", ";width:45%;}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(50));
var Benefit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefit",
  componentId: "sc-1wbd4o9-6"
})(["display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;width:50%;margin-bottom:", ";@media (min-width:", "px){width:25%;margin-bottom:0;}@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.lg */.A.lg);
var BenefitNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitNumber",
  componentId: "sc-1wbd4o9-7"
})(["font-size:", ";font-family:", ";font-weight:700;color:", ";padding-right:", ";white-space:nowrap;"], (0,polished_esm/* rem */.hO)(48), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.fontSecondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(15));
var BenefitLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitLabel",
  componentId: "sc-1wbd4o9-8"
})(["font-weight:", ";font-size:", ";text-align:center;line-height:", ";@media (min-width:", "px){text-align:left;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
var Hero_elements_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1wbd4o9-9"
})(["font-weight:", ";font-size:", ";font-family:", ";margin-top:", ";@media (min-width:", "px){font-size:", ";margin-top:0;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textBold;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h3;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1wbd4o9-10"
})(["color:", ";font-size:", ";padding:", " 0;line-height:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.grey;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30));
;// CONCATENATED MODULE: ./src/components/HomepageHero/Hero.tsx










var HeroTemplate = function HeroTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Hero_elements_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Top, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroLink, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroImage, {
          src: (0,url_utils/* publicAssets */.VK)('/home_hero.webp'),
          alt: t('homepage.hero.title')
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Hero_elements_Title, {
          children: t('homepage.hero.title')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          children: t('homepage.hero.description')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: function onClick() {
            return router.push({
              pathname: constants/* ROUTES.TRAININGS */.Z6.TRAININGS
            });
          },
          text: t('homepage.hero.button.primary'),
          marginBottom: 15
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefits, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit1.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit2.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit3.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit4.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);
;// CONCATENATED MODULE: ./src/components/MyAccountHome/MyAccount.elements.tsx




var MyAccount_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyAccountelements__Wrapper",
  componentId: "sc-10fl1cf-0"
})(["padding:", ";margin-top:", ";display:flex;gap:", ";flex-wrap:wrap;@media (min-width:", "px){margin-top:", ";}@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(10));
var MyAccount_elements_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyAccountelements__Section",
  componentId: "sc-10fl1cf-1"
})(["background:", ";height:", ";padding:", ";border-radius:", ";position:relative;display:flex;width:calc(50% - ", ");margin-top:", ";align-items:flex-end;font-weight:", ";font-size:", ";cursor:pointer;@media (min-width:", "px){width:calc(25% - ", ");height:", ";}span{word-spacing:", ";}svg{width:", ";height:", ";position:absolute;left:", ";top:", ";padding:", ";background:", ";border-radius:50%;}&:hover,&:focus-visible{background:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyMedium;
}, (0,polished_esm/* rem */.hO)(200), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(250), (0,polished_esm/* rem */.hO)(9999), (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(17), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.border;
});
;// CONCATENATED MODULE: ./src/components/MyAccountHome/MyAccount.tsx










var MyAccountTemplate = function MyAccountTemplate() {
  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MyAccount_elements_Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MyAccount_elements_Section, {
      onClick: function onClick() {
        return router.push({
          pathname: constants/* ROUTES.MY_PV_COURSES */.Z6.MY_PV_COURSES
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
        name: Icon/* Icons.MyCourses */.PJ.MyCourses
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: t('header.myCourses')
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MyAccount_elements_Section, {
      onClick: function onClick() {
        return router.push({
          pathname: constants/* ROUTES.MY_PV_CONFERENCES */.Z6.MY_PV_CONFERENCES
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
        name: Icon/* Icons.MyConferences */.PJ.MyConferences
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: t('header.myConferences')
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MyAccount_elements_Section, {
      onClick: function onClick() {
        return router.push({
          pathname: constants/* ROUTES.MY_PV_FAVOURITES */.Z6.MY_PV_FAVOURITES
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
        name: Icon/* Icons.MyFavourites */.PJ.MyFavourites
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: t('header.myFavourites')
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MyAccount_elements_Section, {
      onClick: function onClick() {
        return router.push({
          pathname: constants/* ROUTES.MY_PV_MATERIALS */.Z6.MY_PV_MATERIALS
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
        name: Icon/* Icons.MyMaterials */.PJ.MyMaterials
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        dangerouslySetInnerHTML: {
          __html: t('header.myMaterials')
        }
      })]
    })]
  });
};

/* harmony default export */ var MyAccount = (MyAccountTemplate);
// EXTERNAL MODULE: ./src/ui/Divider/Divider.tsx + 1 modules
var Divider = __webpack_require__(96770);
// EXTERNAL MODULE: ./src/components/Exhibitors/Exhibitors.tsx + 1 modules
var Exhibitors = __webpack_require__(67450);
;// CONCATENATED MODULE: ./src/pages/index.tsx




















var FrontPage = function FrontPage(_ref) {
  var events = _ref.events,
      eventsCount = _ref.eventsCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)(false),
      isLoggedIn = _useState[0],
      setIsLoggedIn = _useState[1];

  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.homepage.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), isLoggedIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MyAccount, {})
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Hero, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      mobileSidePadding: 20,
      children: eventsCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Calendar_Calendar, {
        events: events,
        count: eventsCount
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyCourses/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(References, {
      titleKey: 'homepage.references.title'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Clients/* default */.Z, {
      titleKey: 'homepage.clients.title',
      showClients: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var pages = (FrontPage);

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 96770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Dividerelements__Wrapper",
  componentId: "sc-1b0a3wd-0"
})(["height:1px;width:100%;background:", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, function (prop) {
  return prop.marginTop ? "margin-top: ".concat((0,polished_esm/* rem */.hO)(prop.marginTop)) : '';
}, function (prop) {
  return prop.marginBottom ? "margin-bottom: ".concat((0,polished_esm/* rem */.hO)(prop.marginBottom)) : '';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.tsx




var DividerTemplate = function DividerTemplate(_ref) {
  var marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    marginTop: marginTop,
    marginBottom: marginBottom
  });
};

/* harmony default export */ var Divider = (DividerTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(46339);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97829)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,354,5675,6066,5897,6510,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);